import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AuthGate({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2f3e36]"></div>
      </div>
    );
  }

  if (user) return children;

  return (
    <div className="pw-container py-16 flex items-center justify-center min-h-[60vh]">
      <div data-testid="auth-gate" className="max-w-md w-full bg-[#fbfaf8] border border-[#e7e3dd] rounded-2xl p-10 text-center">
        <div className="w-14 h-14 mx-auto mb-6 flex items-center justify-center">
          <Lock size={36} className="text-[#6f6a63]" strokeWidth={1.5} />
        </div>
        <h2 className="text-xl font-semibold text-[#2d2d2d] mb-3">Log in to see prices and order</h2>
        <p className="text-sm text-[#6f6a63] mb-8">Prices and purchasing are available exclusively for registered customers.</p>
        <div className="flex gap-4 justify-center">
          <Link
            to="/login"
            data-testid="auth-gate-signin"
            className="bg-[#2f3e36] text-white px-8 py-3 rounded-lg text-sm tracking-wider uppercase font-medium hover:bg-[#253029] transition-colors"
          >
            Sign In
          </Link>
          <Link
            to="/register"
            data-testid="auth-gate-register"
            className="border border-[#e7e3dd] px-8 py-3 rounded-lg text-sm tracking-wider uppercase font-medium text-[#2d2d2d] hover:bg-white transition-colors"
          >
            Register
          </Link>
        </div>
      </div>
    </div>
  );
}
